//Import Dependencies
import * as React from 'react';
import { useEffect, useState } from "react";
import moment from 'moment';
import Radio from 'antd/lib/radio';
import Button from 'antd/lib/button';
import Table from 'antd/lib/table';
import Dropdown from 'antd/lib/dropdown';
import Menu from 'antd/lib/menu';
import Badge from 'antd/lib/badge';
import Modal from 'antd/lib/modal';
import Input from 'antd/lib/input';
import Checkbox from 'antd/lib/checkbox';
import Row from 'antd/lib/row';
import Col from 'antd/lib/col';
import notification from 'antd/lib/notification';
import { useCtx } from "one-ui-provider";
import Select from "antd/lib/select";
import Typography from "antd/lib/typography";
import Skeleton  from 'antd/lib/skeleton';
import {
    useSelector,useDispatch
  } from 'react-redux';
import {
    AppointmentData
} from 'one-model-local';
const { TextArea } = Input
import {
    TableLight
} from 'one-ui-table';

import {
    AppointmentsModel,
} from './model';

import './style.less';

import {
    AppointmentsCardProps,
} from './props';

import {
    checkCardHasError,
    TabErrorMsg
} from 'one-card-notification';

const { Option } = Select;
const { Text } = Typography;



/**
 * This function returns all the appointments
 * @param props has all input parameters to load the Card
 * @returns JSX code for Appointments
 */
export const AppointmentCard = <M extends AppointmentsModel>(
    props: AppointmentsCardProps<M>
) => {
    const {
        model,
        title,
        onAppointmentTypeChange,
        appointmentType,
        canConfirmAppointment,
        onAppointmentScreenpopChange,
        onCancelAppointment,
        onConfirmAppointment,
        onUpdateAppointment,
        useridType,
        canUpdateappointment
    } = props;

    const {
        data,
        appointmentSelectedType,
    } = model;
    const dispatch = useDispatch();
    const callerevents = useSelector((state: any) => (state.voice));
    const epicuserid = useSelector((state:any) => (state.epicuserid));
    const skeleton = useSelector((state: any) => (state.skeleton));
    const { log, settings } = useCtx();
    const { uisettings: { cancelappointment },compatible,appointment_config:{ArrivalTime} } = settings;
    const {useridtype } = compatible;
    const { cancelappointmentdropdown, ciscocommentscheckbox,appendepicuserid, ciscocomments = [], reason = [] } = cancelappointment;

    let appdata: AppointmentData = {};
    let commentvalues: any = '';
    let apptBodyUI;
    const [appmodel, setAppmodel] = useState('');
    const [selectedappdetails, setSelectedappdetails] = useState(appdata);
    const [appreason, setAppreason] = useState('');
    const [appcomments, setAppcomments] = useState('');
    const [ciscocommentvalue, setCiscocommentvalue] = useState('');
    const [checkboxval, setCheckboxval] = useState(false);
    const [charactercount, setCharacterCount] = useState(0);
    let appointmentCount : any = {}

    if (data && data.length > 0) {
        for (const item of data) {
            if (appointmentCount[item.appointmentType]) {
                appointmentCount[item.appointmentType]++;
            } else {
                appointmentCount[item.appointmentType] = 1;
            }
        }
    }

    let newData = (data && data.length > 0) ? data.sort((item1: any, item2: any) => {
        if (new Date(item1.date) > new Date(item2.date)) return 1
        if (new Date(item1.date) < new Date(item2.date)) return -1
        
        const itemTime1 = moment(item1?.appointmentTime?.replace(/\s/g, ''), 'h:mma');
        const itemTime2 = moment(item2?.appointmentTime?.replace(/\s/g, ''), 'h:mma');
        
        if (itemTime1.isBefore(itemTime2)) return -1
        if (itemTime2.isBefore(itemTime1)) return 1
        return 0
    }) : []

    //To Filter on basis of appointmentSelectedType from the Front End UI.
    const finaldata = newData?.filter((object: any) =>
        (object.appointmentType === appointmentSelectedType ? appointmentSelectedType : ""));

    // To set the Reasons drop down
    let optionvalues: any = [];
    reason && reason.forEach((event: any) => {
        optionvalues.push(<Option key={event.value} value={event.value ? event.value : "NA"}> {event.label}</Option>);
    })
    const [dropdown] = useState(optionvalues);

    /**
     *  Adds cisco comments to Hook from callerEvents.
     */
    useEffect(() => {
    //To set the cisco comments
    if (callerevents && ciscocommentscheckbox) {
        if (callerevents.data) {
            Object.entries(callerevents.data).forEach(([key, value]) => {
                //do something with key and val
                log.debug(
                    'one-card-appointments-table',
                    'ciscocomment-key-value', {
                    key,
                    value
                }
                );

                ciscocomments.forEach((element: any) => {
                    if (key && element && key === element) {
                        commentvalues += key.concat(":");
                        let val: any = value;
                        commentvalues += val.concat(",");
                    }
                });
            });
            if (commentvalues && commentvalues.length > 0) {
                commentvalues = commentvalues.slice(0, -1);
            }
            setCiscocommentvalue(commentvalues);
        }
    }
    }, [callerevents]);
    

    const handleMenuClick = (e: any) => {
        let key = e.key;
        let res = key.split(",");
        if (res[1] === '1') {
            handleApptScreenPopClick(e);
        }
        else if (res[1] === '2') {
            setAppmodel('Cancel');
            data.forEach((rec: any) => {
                if (res[0] === rec.key.toString()) {
                    setSelectedappdetails(rec);
                }
            });
        }
        else if (res[1] === '3') {
            setAppmodel('Confirm');
            data.forEach((rec: any) => {
                if (res[0] === rec.key.toString()) {
                    setSelectedappdetails(rec);
                }
            });
        }
        else if (res[1] === '4') {
            setAppmodel('Update');
            data.forEach((rec: any) => {
                if (res[0] === rec.key.toString()) {
                    setAppcomments(rec.AppointmentNotes)
                    setCharacterCount(Object.keys(rec.AppointmentNotes).length)
                    setSelectedappdetails(rec);
                }
            });
        }
    }

    const handleApptScreenPopClick = (e: any) => {
        if (onAppointmentScreenpopChange) {
            onAppointmentScreenpopChange(e);
        }
    }

    const handleAPPCancel = (e: any) => {
        setAppmodel('');
        setAppreason('');
        setAppcomments('');
        setCiscocommentvalue('');
        setCheckboxval(false);
        setCharacterCount(0)
    };

    const handleAppcomments = (event: any) => {
        //To  track the Character Count 
        if(event.target.value.length<=450){
           setAppcomments(event.target.value);
           setCharacterCount(event.target.value.length)
       }       
    }

    const handleAppreason = (event: any) => {
        setAppreason(event);
    }

    const addCiscoComments = (event: any) => {
        if (event.target.checked) {
            setCheckboxval(true);
        } else {
            setCheckboxval(false);
        }
    }

    const handleDelete = (e: any) => {
        if (appreason === '' || appreason === undefined || appreason === null) {
            notification.config({
                placement: "topRight",
                top: 300,
                duration: 3
            });
            notification['error']({
                message: 'Alert',
                description:
                    'Enter reason for appointment cancellation',
            });
        } else {
            //Appended Epic UserID with the Commemnts
            let appcomment = "", appcommentinfo = "", epicuserinfo = "";
            try {
                if (checkboxval) {
                    appcommentinfo = appcomments.concat(" | Cisco Details:").concat(ciscocommentvalue);
                } else {
                    appcommentinfo = appcomments;
                }
                //Check for the config value for appending the epic userid
                if (appendepicuserid) {
                    epicuserinfo = epicuserid?.agentuserid;
                    appcomment = epicuserinfo + ":" + appcommentinfo
                }
                else {
                    appcomment = appcommentinfo
                }

                const payload = {
                    PatientID: e.patientId,
                    PatientIDType: e.patientIDType,
                    ContactID: e.contactID,
                    ContactIDType: e.contactIDType,
                    //"PatientIDType": e.patienttype,
                    //ContactID: e.contactid,
                    //"ContactIDType": e.contacttype,
                    Reason: appreason,
                    Comment: appcomment
                }
                log.debug(
                    'one-card-appointments-table',
                    'cancelled-appointment-data', {
                    payload
                }
                );
                onCancelAppointment(payload);
                handleAPPCancel(null);
                setCharacterCount(0);
                //Making the skeleton until we get the updated data.
                dispatch ({
                    type: "one-state-skeleton/set",
                    payload:{
                        upcomingAppts_skeleton: true,
                    }
                })
            } catch (error: any) {
                console.log(error)
            }
        }
    };

    const handleConfirm = (e: any) => {
        const payload = {
            "PatientID": e.patientId?.trim(),
            "PatientIDType":e.patientIDType.trim(),
            "ContactID": e.contactID?.trim(),
            "ContactIDType": e.contactIDType?.trim(),
            "NotificationResponse": "Confirmed",
            "CommunicationType": "1",
            "UserID":"1",
            "UserIDType": useridtype
        }

        log.debug(
            'one-card-appointments-table',
            'confirmed-appointment-data', {
                payload
            }
        );
        onConfirmAppointment(payload)
        handleAPPCancel(null)
    }
    /*update notes*/
    /*update notes*/
    const handleUpdate = (e: any) => {
        console.log(e,"eeee",useridType,appcomments);
        const payload = {
            "PatientID": e.patientId?.trim(),
            "PatientIDType":e.patientIDType?.trim(),
            "UserID":1,
            "UserIDType":useridType,
            "ContactID": e.contactID?.trim(),
            "ContactIDType":e.contactIDType?.trim(),
            "notes": appcomments
        }

        log.debug(
            'one-card-appointments-table',
            'update-appointment-data', {
                payload
            }
        );
        if(appcomments.toUpperCase() === e.AppointmentNotes.toUpperCase()) {
            notification.config({
                placement: "topRight",
                top: 200,
                duration: 3
            });
            notification['warn']({
                message: 'This message is already updated',
                description:"",
            });
        }
        else {
            onUpdateAppointment(payload)
            handleAPPCancel(null)
            setTimeout(() => {
                dispatch(
                  {
                    type: "set-appointments-success",
                    payload: {id:e.patientId.trim()}
                  }
                )
              }, 2000);
        }
    }

    /**
     * This fuction is used to create Menu.
     * @param e record id
     */
    const menu = (e: any) => (
        <Menu onClick={handleMenuClick}>
            {/* <Menu.Item key={e.key + ",1"}>Show Appointments in Epic</Menu.Item> */}
            {
                cancelappointmentdropdown
                &&
                (appointmentSelectedType === 'future')
                &&
                (<Menu.Item key={e.key + ",2"}>Cancel Appointment</Menu.Item>)
            }
            {
                canConfirmAppointment && (appointmentSelectedType === 'future')
                &&
                (<Menu.Item key={e.key + ",3"}>Confirm Appointment</Menu.Item>)
            }
            {
               canUpdateappointment &&
                (<Menu.Item key={e.key + ",4"}>Edit Notes</Menu.Item>)
            }
        </Menu>
    );

    let columns = [
        {
            title: 'Appointment Date',
            render: (text: any, record: any) => (
                <div>{record.date} {record.appointmentTime}</div>
            ),
            key: 'date',
        },
        {
            title: 'Day',
            dataIndex: 'day',
            key: 'day',
        },
        {
            title: 'Department',
            dataIndex: 'department',
            key: 'department',
        },
        {
            title: 'Provider',
            dataIndex: 'provider',
            key: 'provider',
        },
        {
            title: 'Visit Type',
            dataIndex: 'visitType',
            key: 'visitType',
        },
        {
            title: 'Notes',
            dataIndex: 'AppointmentNotes',
            key: 'AppointmentNotes',
            ellipsis:true
        },
    ];
    if(appointmentSelectedType === 'future' && ArrivalTime===true){
        columns.push( {
            title: 'ArrivalTime',
            dataIndex: 'ArrivalTime',
            key: 'ArrivalTime',
        })
        columns.push( {
            title: "Action",
            key: "action",
            render: (text: any, record: any) => (
                <Dropdown overlay={menu(record)}>
                    <Button type="link" size="small" className="ant-btn-link--dark">&hellip;</Button>
                </Dropdown>
            )
        })
    }
    else{
        columns.push( {
            title: "Action",
            key: "action",
            render: (text: any, record: any) => (
                <Dropdown overlay={menu(record)}>
                    <Button type="link" size="small" className="ant-btn-link--dark">&hellip;</Button>
                </Dropdown>
            )
        })
    }

    // To Check for the Error from the API
    if(checkCardHasError("Appointments") && finaldata.length === 0) {
        apptBodyUI = 
        <>
            <TabErrorMsg />
        </>
    }
    else {
        apptBodyUI = 
        <Skeleton loading={skeleton?.upcomingAppts_skeleton} active title={true} paragraph={{ rows: 3 }}>
        <Table className="ant-table--styled" columns={columns} dataSource={finaldata} pagination={{ pageSize: 7 }} />
        </Skeleton>
    }

    return (
        <div>
            <TableLight
                title={title}
                screnpopepicbutton={<Button style={{backgroundColor:"#e84a13",color:"#fff"}} onClick={()=>handleApptScreenPopClick(selectedappdetails)}>Open Appointment Desk In EPIC</Button>}
                headerButtons={
                    <Radio.Group defaultValue="future" size="small" className="ant-radio-group--small">
                        {
                            appointmentType?.map(({ label, id }) => (
                                <Badge showZero count={appointmentCount[id] || 0} key={id}>
                                    <Radio.Button value={id} onChange={
                                        (value: any) => {
                                            if (onAppointmentTypeChange) {
                                                onAppointmentTypeChange(value.target.value);
                                            }
                                        }}>
                                        {label}
                                    </Radio.Button>
                                </Badge>
                            ))
                        }
                    </Radio.Group>
                }
                body={apptBodyUI}
            />
            <Modal
                title={`${appmodel} Appointment`}
                width={708}
                visible={appmodel !== ''}
                footer={null}
                centered
                closable={true}
                onCancel={handleAPPCancel}
                wrapClassName="custom-modal-wrap"
                destroyOnClose
            >

                <Row type="flex" gutter={[16, 16]}>
                    <Col span={12}>
                        <div className={'description-info'}>
                            <div className="description-info__item">
                                <b>{"Appointment Date"}:</b> {selectedappdetails.date} {selectedappdetails.appointmentTime}
                            </div>
                        </div>
                        <div className={'description-info'}>
                            <div className="description-info__item">
                                <b>{"Department"}:</b> {selectedappdetails.department}
                            </div>
                        </div>
                    </Col>
                    <Col span={12}>
                        <div className={'description-info'}>
                            <div className="description-info__item">
                                <b>{"Provider"}:</b> {selectedappdetails.provider}
                            </div>
                        </div>
                        <div className={'description-info'}>
                            <div className="description-info__item">
                                <b>{"Visit Type"}:</b> {selectedappdetails.visitType}
                            </div>
                        </div>
                    </Col>
                </Row>
                <div className="ant-modal-hr" />
                {appmodel === 'Update' && (
                    <Row type="flex" gutter={[24, 24]}>
                        <Col span={24}>
                            <div className={'description-info'}>
                                <div className="description-info__item">
                                    <b>{"Notes"}:</b>
                                </div>
                            </div>
                            <TextArea rows={3} onChange={handleAppcomments} value={appcomments} />
                            <Text className='comment-box-text'>Max 450 Characters</Text>
                            <Text className='count-value'>{charactercount}/450</Text>
                        </Col>
                    </Row>
                )}
                {appmodel === 'Cancel' && (
                    <Row type="flex" gutter={[24, 24]}>
                        <Col span={24}>
                            <div className={'description-info'}>
                                <div className="description-info__item">
                                    <b>{"Reason"}:</b>
                                </div>
                            </div>
                            <Select size="default" style={{ width: "100%" }} onSelect={(key: string) => (
                                handleAppreason(key)
                            )}>
                                {dropdown}
                            </Select>
                        </Col>
                        <Col span={24}>
                            <div className={'description-info'}>
                                <div className="description-info__item">
                                    <b>{"Comments"}:</b>
                                </div>
                            </div>
                            <TextArea className='comment-text-area' rows={3} onChange={handleAppcomments} value={appcomments} maxLength={450}/>
                            <Text className='comment-box-text'>Max 450 Characters</Text>
                            <Text className='count-value'>{charactercount}/450</Text>
                        </Col>
                        <Col span={24}>
                            {ciscocommentscheckbox && (<Checkbox onChange={addCiscoComments} checked={checkboxval}>Add Cisco details to comments</Checkbox>)}
                        </Col>
                    </Row>
                )}
                <div className="ant-modal-actions">
                    {appmodel === 'Cancel' && (
                        <Button key="submit" type="primary" onClick={() => handleDelete(selectedappdetails)}>
                            Cancel Appointment
                        </Button>
                    )}
                    {appmodel === 'Confirm' && (
                        <Button key="submit" type="primary" onClick={() => handleConfirm(selectedappdetails)}>
                            Confirm Appointment
                        </Button>
                    )}
                    {appmodel === 'Update' && (
                        <Button key="submit" type="primary" onClick={() => handleUpdate(selectedappdetails)}>
                        Update 
                        </Button>
                    )}
                </div>
            </Modal>
        </div>
    );
};
